/**
 * Feature flags
 */

// enum value must match flag key in LaunchDarkly
export enum FeatureFlag {
    ADDITIONAL_BILLING_FIELDS_POSTCODE = 'additional-billing-fields-postcode',
    AI_REVIEW_REPLY = 'ai-review-reply',
    AI_SITES = 'ai-sites',
    ALLOW_EMAIL_LINKS = 'allow-email-links',
    ALLOW_SMS_LINKS = 'allow-sms-links',
    ALLOWED_TEST_RECIPIENTS = 'allowed-test-recipients',
    ATOM_ACTIVATION_FLOW = 'atom-activation-flow',
    ATOM_REFERRALS = 'atom-referrals',
    // @todo #7225 remove after back-fill completion
    BLOCK_BACKFILL_IMPORTS = 'block-backfill-imports',
    BLOCK_SIGNUP = 'block-signup',
    CAMPAIGNS_V2_OBJECTIVE_BOOKINGS = 'campaigns-v2-objective-bookings',
    CAMPAIGNS_V2_UNSUBSCRIBE_COLUMN = 'campaigns-v2-unsubscribe-column',
    COMPANY_IS_VERIFIED = 'company-is-verified',
    FEEDBACK_ROUTING_SETTINGS = 'feedback-routing-settings',
    GET_REPEAT_BUSINESS_ADVANCED_RULES = 'get-repeat-business-advanced-rules',
    GET_REPEATS_CAMPAIGN_INSIGHTS = 'get-repeats-campaign-insights',
    GIFT_CAMPAIGN_PHASE_0 = 'gift-campaign-phase-0',
    GOALS = 'goals',
    JOBBER_CUSTOM_FIELD = 'jobber-custom-field',
    MULTI_FACTOR_AUTHENTICATION = 'multi-factor-authentication',
    NPS_CAMPAIGN = 'nps-campaign',
    ONBOARDING_WITH_PHONE_VERIFICATION = 'onboarding-with-phone-verification',
    PAYMENTS_EXPLORE_REVIEWS = 'payments-explore-reviews',
    PEOPLE_SEGMENTS = 'people-segments',
    RECOMMENDATION_LEAD_ALERT = 'recommendation-lead-alert',
    RECOMMENDATIONS = 'recommendations',
    REFERRALS_PRO = 'referrals-pro',
    SEND_TEST_MESSAGE = 'send-test-message',
    USE_SUGARWISH_TEST_ACCOUNT_IN_PRODUCTION = 'use-sugarwish-test-account-in-production',
    WIN_REPEAT_BUSINESS_CAMPAIGN = 'win-repeat-business-campaign',
}

export enum BlockSignupCheckResult {
    BLOCK = 'BLOCK',
    NOTIFY = 'NOTIFY',
    ALLOW = 'ALLOW',
}

export interface IMLModelConfig {
    version: {
        major: MLModelMajorVersion;
        minor: MLModelMinorVersion;
    };
}

// model major version
export enum MLModelMajorVersion {
    V1 = 'ionian',
    V2 = 'dorian',
    V3 = 'phrygian',
    V4 = 'lydian',
    V5 = 'mixolydian',
    V7 = 'aeolian',
    V8 = 'locrian',
}

// model minor version
export enum MLModelMinorVersion {
    V1 = 'unison',
    V2 = 'minor_second',
    V3 = 'major_second',
    V4 = 'minor_third',
    V5 = 'major_third',
    V6 = 'perfect_fourth',
    V7 = 'tritone',
    V8 = 'perfect_fifth',
    V9 = 'minor_sixth',
    V10 = 'major_sixth',
    V11 = 'minor_seventh',
    V12 = 'major_seventh',
    V13 = 'octave',
    V14 = 'compound_minor_second',
    V15 = 'compound_major_second',
    V16 = 'compound_minor_third',
    V17 = 'compound_major_third',
    V18 = 'compound_perfect_fourth',
    V19 = 'compound_tritone',
    V20 = 'compound_perfect_fifth',
    V21 = 'compound_minor_sixth',
    V22 = 'compound_major_sixth',
    V23 = 'compound_minor_seventh',
    V24 = 'compound_major_seventh',
    V25 = 'double_octave',
}

/**
 * Feature flag check result types
 */
export interface FeatureFlagCustomCheckResultMap {
    [FeatureFlag.BLOCK_SIGNUP]: BlockSignupCheckResult;
}

export type FeatureFlagCheckResult<
    Flag extends FeatureFlag | 'default'
> = Flag extends keyof FeatureFlagCustomCheckResultMap
    ? FeatureFlagCustomCheckResultMap[Flag]
    : boolean;
